import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';
import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {UserSearchType} from 'ui-library/entity-input/EntityInputWithSearch';

import {UsersFilterFormQuery} from './__generated/UsersFilterFormQuery';
import PartiesApiIdFilterForm, {PartiesApiIdFilterFormProps} from './PartiesApiIdFilterForm';

export const USERS_FILTER_FORM_QUERY: DocumentNode = gql`
  query UsersFilterFormQuery @skipAudit @engComponent(name: SIGHTGLASS) {
    currentTenantOrganizations {
      id
      members {
        ... on UserNode {
          id
          name
          handle
        }
      }
    }
  }
`;

// Populates filter with the users' API ID. Use UsersFilterForm if you need the filter to be populated
// with the users' handle.
export default function UsersApiIdFilterForm(props: PartiesApiIdFilterFormProps): JSX.Element {
  return (
    <BenchlingQuery<UsersFilterFormQuery>
      query={USERS_FILTER_FORM_QUERY}
      renderLoading={() => (
        <PartiesApiIdFilterForm
          {...props}
          allowTeams={false}
          allowOrganizations={false}
          allTeams={[]}
          allOrganizations={[]}
          allUsers={[]}
          userSearchType={UserSearchType.All}
        />
      )}
    >
      {(data) => {
        const organizations = data.currentTenantOrganizations ?? [];
        return (
          <PartiesApiIdFilterForm
            {...props}
            allowTeams={false}
            allowOrganizations={false}
            allTeams={[]}
            allOrganizations={organizations}
            allUsers={organizations.map(({members}) => members).flat() ?? []}
            userSearchType={UserSearchType.All}
          />
        );
      }}
    </BenchlingQuery>
  );
}
